const states = {
  AU: [
    'New South Wales',
    'Victoria',
    'Queensland',
    'Tasmania',
    'South Australia',
    'Western Australia',
    'Northern Territory',
    'Australian Capital Territory',
  ],
  CA: [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon Territory',
  ],
  NZ: [
    'Northland',
    'Auckland',
    'Bay of Plenty',
    'Gisborne',
    "Hawke's Bay",
    'Taranaki',
    'Manawatu-Wanganui',
    'Wellington',
    'West Coast',
    'Canterbury',
    'Otago',
    'Southland',
    'Tasman',
    'Nelson',
    'Marlborough',
    'Waikato',
  ],
  US: [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
};

export const orderedStateList = (countryCode: string) => {
  try {
    const indexedStateMap = (states as { [key: string]: string[] })[countryCode];
    if (typeof indexedStateMap === 'object') {
      return (states as { [key: string]: string[] })[countryCode].sort();
    } else {
      return [''];
    }
  } catch (err: any) {
    console.warn(err.message);
    return [''];
  }
};

export default states;
